import * as API_USER_DASHBOARD_SERVICE from '@/drc/services/drc-request-service';
// import {NOTIFICATION_TYPE} from '@/common/utils/constants';

const userMixin = {
	methods: {
		redirectToSubmissionForm() {
			this.$router.push({name: 'submission-new-project-form'});
			// const isActiveDrafts = true;
			// API_USER_DASHBOARD_SERVICE
			// 	.getUserDraftProjectsCount(this.$store.getters.getUser.id, isActiveDrafts)
			// 	.then((response) => {
			// 		let userDraftsCount = response.data.count
			//
			// 		if (userDraftsCount >= 25) {
			// 			this.showNotification(`${this.$t('notifications.maxDraftStories')}`, NOTIFICATION_TYPE.ERROR);
			// 		} else {
			// 			this.$router.push({name: 'submission-new-project-form'});
			// 		}
			// 	})
			// 	.catch((error) => {
			// 		console.error(error)
			// 	});
		},
		async getUserDraftProjectsCounts(isActiveDrafts) {
			let response = await API_USER_DASHBOARD_SERVICE.getUserDraftProjectsCount(
				this.$store.getters.getUser.id,
				isActiveDrafts
			);

			return response.data.count;
		}
	}
}

export default userMixin;
